import React, { Fragment, useContext } from 'react'
import { TypeProcess } from './TypeProcess/TypeProcess'
import { Parameters } from './Parameters/Parameters'
import { Container, Paper } from '@mui/material'
import { useStyles } from './styles'
import { EnumConfigurationTab } from '../../utils/configurationTab'
import { ConfigurationContext } from './configurationContext'

interface ConfigurationsProps {}

export const Configurations: React.FC<ConfigurationsProps> = () => {
  const classes = useStyles()

  const { state } = useContext(ConfigurationContext)

  const { typeConfiguration } = state

  return (
    <Fragment>
      <Container maxWidth='xl' className={classes.grid}>
        <Paper elevation={2} className={classes.paper}>
          {typeConfiguration === EnumConfigurationTab.PARAMETROS ? (
            <Parameters />
          ) : (
            <TypeProcess />
          )}
        </Paper>
      </Container>
    </Fragment>
  )
}
